import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";

import SpeakerAnalyticMenuIcon from "./speakers-menu-icon";
import TableContentTopSpeaker from "./table-content-top-speaker";
import TableContentMostsearchSpeaker from "./table-content-mostsearch-speaker";
import SpeakeranalyticEngmntBarChart from "./speakeranalytic-engmnt-barchart";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";

import {
  fetchTopSpeakerTableData,
  fetchMostsearkeysTableData,
  fetchspkrengagementbBarChart,
} from "SpeakeranalyticActions";
import { speakernoofspkrcount } from "SpeakeranalyticNoofspkrAction";
import { speakerspkrlistviewcount } from "SpeakeranalyticSpkrlistviewAction";
import { speakerspkrprofviewcount } from "SpeakeranalyticSpkrprofviewAction";
import { speakerspkrfavocount } from "SpeakeranalyticSpkrfavoAction";
import { SpeakerSearchCount } from "SpeakeranalyticSpkrsearchAction";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class SpeakerInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
      loader: false,
    };
  }

  //
  componentDidMount() {
    this.props.speakernoofspkrcount(
      this.props.session,
      (speakernoofspkrresponse) => {
        if (speakernoofspkrresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrlistviewcount(
      this.props.session,
      (speakerspkrlistviewresponse) => {
        if (speakerspkrlistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrprofviewcount(
      this.props.session,
      (speakerspkrprofviewresponse) => {
        if (speakerspkrprofviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to Number of searches done on speaker list
    this.props.SpeakerSearchCount(
      this.props.session,
      (speakersearchcountResponse) => {
        if (speakersearchcountResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrfavocount(
      this.props.session,
      (speakerspkrfavocountresponse) => {
        if (speakerspkrfavocountresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call Top Speakers Table data list
    this.props.fetchTopSpeakerTableData(
      this.props.session,
      (fetchtopspeakertabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Top Speakers Table data list
    this.props.fetchMostsearkeysTableData(
      this.props.session,
      (fetchmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to speaker bar chart
    this.props.fetchspkrengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchspkrengagementbbarchartResponce) => {
        this.setState({ loading: false });
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Speaker Insights menu divs
  renderSpeakeranalyticMenuIcons() {
    return _.map(this.props.speakerAnalyticMenu, (speakeranalyticmenuItem) => {
      return (
        <SpeakerAnalyticMenuIcon
          menu={speakeranalyticmenuItem}
          key={speakeranalyticmenuItem.key}
        />
      );
    });
  }

  // Send function with props for barchartdate change
  onDateChartChangeFc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });
    this.props.speakernoofspkrcount(
      this.props.session,
      (speakernoofspkrresponse) => {
        if (speakernoofspkrresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrlistviewcount(
      this.props.session,
      (speakerspkrlistviewresponse) => {
        if (speakerspkrlistviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrprofviewcount(
      this.props.session,
      (speakerspkrprofviewresponse) => {
        if (speakerspkrprofviewresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call to Number of searches done on speaker list
    this.props.SpeakerSearchCount(
      this.props.session,
      (speakersearchcountResponse) => {
        if (speakersearchcountResponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.speakerspkrfavocount(
      this.props.session,
      (speakerspkrfavocountresponse) => {
        if (speakerspkrfavocountresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    // Call Top Speakers Table data list
    this.props.fetchTopSpeakerTableData(
      this.props.session,
      (fetchtopspeakertabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call Top Speakers Table data list
    this.props.fetchMostsearkeysTableData(
      this.props.session,
      (fetchmostsearkeystabledataResponce) => {
        this.setState({ loading: false });
      }
    );

    // Call to speaker bar chart
    this.props.fetchspkrengagementbBarChart(
      this.props.session,
      this.props.datePropsMainPg,
      (fetchspkrengagementbbarchartResponce) => {
        this.setState({ loading: false });
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="Speakers"
            xchart={this.onDateChartChangeFc.bind(this)}
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.renderSpeakeranalyticMenuIcons()}
              </ul>
              <div className="mt-20"></div>
              <div className="panel-body ">
                {this.props.spkrbarchart ? (
                  <SpeakeranalyticEngmntBarChart
                    spkrbarchart={this.props.spkrbarchart}
                    newprop={this.state.loader}
                  />
                ) : (
                  ""
                )}
                <TableContentTopSpeaker />
                <TableContentMostsearchSpeaker />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, speakerAnalyticMenu, speakerSelectedItem } = state;
  //
  var totalnoofspkr = state.speakerAnalyticTotalNoofspkr
    ? state.speakerAnalyticTotalNoofspkr
    : [];
  var totalspkrlistview = state.speakerAnalyticTotalSpkrlistview
    ? state.speakerAnalyticTotalSpkrlistview
    : [];
  var totalspkrprofview = state.speakerAnalyticTotalSpkrprofview
    ? state.speakerAnalyticTotalSpkrprofview
    : [];
  var totalspkrfavo = state.speakerAnalyticTotalSpkrfavo
    ? state.speakerAnalyticTotalSpkrfavo
    : [];
  var tospkrtablelist = state.speakerTopspkrTablelist
    ? state.speakerTopspkrTablelist
    : [];
  var mostsearkeys = state.speakerMostsearkeysTablelist
    ? state.speakerMostsearkeysTablelist
    : [];
  var spkrbarchart = state.speakerEngagementbarChart
    ? state.speakerEngagementbarChart.response
    : [];
  var datePropsMainPg = state.analyticscommondatepropsreducer;

  //
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    speakerAnalyticMenu,
    speakerSelectedItem,
    totalnoofspkr,
    totalspkrlistview,
    totalspkrprofview,
    totalspkrfavo,
    tospkrtablelist,
    mostsearkeys,
    spkrbarchart,
    datePropsMainPg,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  speakernoofspkrcount,
  speakerspkrlistviewcount,
  speakerspkrprofviewcount,
  speakerspkrfavocount,
  fetchTopSpeakerTableData,
  fetchMostsearkeysTableData,
  fetchspkrengagementbBarChart,
  SpeakerSearchCount,
})(SpeakerInside);
